import { createFileRoute } from "@tanstack/react-router";
import { AdminVerifyPage } from "@/projects/admin/pages/VerifyPage";

export const Route = createFileRoute("/admin/verify/$id")({
  head: () => ({ meta: [{ title: "Verify Submission — Admin" }] }),
  component: AdminVerifyPage,
});
